import { render, staticRenderFns } from "./SingleVolunteerApplication.vue?vue&type=template&id=c3309c28&scoped=true"
import script from "./SingleVolunteerApplication.vue?vue&type=script&lang=js"
export * from "./SingleVolunteerApplication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3309c28",
  null
  
)

export default component.exports